/**
 * Contact Service
 * To construct the template for Call Us page and Email Page
 * Left Side: Email/CallUs
 * Right Side: Find Quick Answers
 */

import React from 'react';
import PropTypes from 'prop-types';
import ErrorHandler from '../containers/ErrorHandler';
import AlertsContainer from '../containers/Alerts';
import ColumnLayout from './common/ColumnLayout';

import ModalContainer from '../containers/ModalContainer';
import { isPrivacyWebFormEnabledInRC } from '../../lib/globalHelper';
import QualtricsFeedbackComponent from '../../common/QualtricsFeedbackComponent';
import i18n from '../../lib/reacti18n';
import { kanaCodes } from '../../common/commonConstants';

// Constants
const contactError = i18n.message('smarthelp/Error.error.contact');

/**
 * New layout for Privacy webform page & AUP Violation page
 * Can be used for any page with the same layout
 */
const getEmailFormLayoutStyle = (kanaCode) => {
  const isNewPrivacyPageEnabledInRC = isPrivacyWebFormEnabledInRC(kanaCode) || false;
  if (isNewPrivacyPageEnabledInRC || kanaCode === kanaCodes.PAYPAL_ME) {
    return 'fourty-sixty-layout';
  }
  return '';
};

const ContactService = function (props) {
  return (
    <ErrorHandler contactError={contactError}>
      <div className="page-main-container">
        <AlertsContainer />
        <ModalContainer />
        <ColumnLayout
          leftPanel={props.leftPanel}
          rightPanel={props.rightPanel}
          customizeStyle={getEmailFormLayoutStyle(props.kanaCode)}
        />
        <QualtricsFeedbackComponent />
      </div>
    </ErrorHandler>
  );
};

// Contact Service PropTypes
ContactService.propTypes = {
  leftPanel: PropTypes.element.isRequired,
  rightPanel: PropTypes.element.isRequired,
  kanaCode: PropTypes.string,
};

export default ContactService;
